import { useIdeStore } from '@/stores/embeds/ide.store'
/**
 * Get default libs
 */
const getDefaultOutputFiles = () => {
  useIdeStore().setOutputFiles([])
}
/**
 * Init language list
 */
const initOutputFiles = () => {
  getDefaultOutputFiles()
}

/**
 * Eject stdin argus
 */
const destroyOutputFiles = () => {
  getDefaultOutputFiles()
}
export default {
  initOutputFiles,
  destroyOutputFiles
}
